import { SearchIndexes } from '@rocco/types/enum/search-indexes';
import { PROJECT_FILTERS_CONFIG } from '@modules-rocco/projects/config/filter.config';
import { PROFESSIONAL_FILTERS_CONFIG } from '@modules-rocco/professionals/config/filter.config';
import { PRODUCT_FILTERS_CONFIG } from '@modules-rocco/products/config/filter.config';

/**
 * Retrieves the appropriate filter configuration based on the provided search index category.
 *
 * @param currentIndex - The current search index category (e.g., 'product', 'professional', 'project').
 * @returns An object containing the filter configuration (`config`) and the corresponding `SearchIndexes` enum value, or `null` if no matching index is found.
 */
export const getFilterSettings = (currentIndex?: string) => {
    switch (currentIndex) {
        case 'product':
        case 'products':
            return {
                config: PRODUCT_FILTERS_CONFIG,
                index: SearchIndexes.Products,
            };

        case 'professional':
        case 'professionals':
            return {
                config: PROFESSIONAL_FILTERS_CONFIG,
                index: SearchIndexes.Professionals,
            };

        case 'project':
        case 'projects':
            return {
                config: PROJECT_FILTERS_CONFIG,
                index: SearchIndexes.Projects,
            };

        default:
            return null;
    }
};
